import React, {useState, useEffect} from "react";
import {TextField, DialogContent, DialogActions} from "@material-ui/core";
import {Button, Grid} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import "react-dropzone-uploader/dist/styles.css";
import {getCookie} from "../../../components/auth/Helpers";

const FilterComponent = (props) => {
  const token = getCookie("token");
  const [clientsList, setClientsList] = useState([]);
  const [fridgesTypesList, setFridgesTypesList] = useState([]);
  const [operationsList, setOperationsList] = useState([]);
  const [statusList, setStatusList] = useState([
    "In Progress",
    "Completed",
    "Failed",
    "On Hold",
    "Assigned",
    "Unassigned",
    "Accepted",
    "Canceled",
  ]);

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/operations`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setClientsList(response[0].data);
          setFridgesTypesList(response[1].data);
          setOperationsList(response[2].data);
        });
    };
    fetchData();
  }, []);

  const handleChangeAutoComplete = (e, newValue, name) => {
    props.setFormFilterValues({...props.formFilterValues, [name]: newValue});
  };

  const handleSearchDate = (e) => {
    const {name, value} = e.target;
    if (value) props.setFormFilterValues({...props.formFilterValues, [name]: value});
  };

  const handleOnSubmit = async () => {
    if (props.fetchTabsData) {
      props.fetchTabsData(props.formFilterValues);
      props.setOpenDialog(false);
      return;
    }
    let filterArray = [];
    if (props.formFilterValues.client && props.formFilterValues.client._id)
      filterArray.push(`clientId=${props.formFilterValues.client._id}`);
    if (props.formFilterValues.fridgesType && props.formFilterValues.fridgesType._id)
      filterArray.push(`fridgeTypeId=${props.formFilterValues.fridgesType._id}`);
    if (props.formFilterValues.operationType && props.formFilterValues.operationType.name)
      filterArray.push(`operationType=${props.formFilterValues.operationType.name}`);
    if (props.formFilterValues.status) filterArray.push(`status=${props.formFilterValues.status}`);
    if (props.formFilterValues.fromDate) filterArray.push(`fromDate=${props.formFilterValues.fromDate}`);
    if (props.formFilterValues.toDate) filterArray.push(`toDate=${props.formFilterValues.toDate}`);
    if (props.searchEntry) filterArray.push(`searchEntry=${props.searchEntry}`);
    await axios(
      `${process.env.REACT_APP_BASE_URL}/financial${props.daily ? "/daily" : ""}?limit=${
        props.pagingInfo.limit
      }&skip=${props.pagingInfo.skip}&${filterArray.join("&")}`,
      {responseType: "json", headers: {Authorization: `Bearer ${token}`}}
    )
      .then(function (response) {
        if (props.daily) {
          props.setItems(response.data);
        } else {
          props.setPagingInfo({...props.pagingInfo, count: response.data.count});
          props.setItems(response.data.data);
        }

        props.setOpenDialog(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <DialogContent>
        <h3>Financial Report Filter</h3>
      </DialogContent>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="ClientInput"
              options={clientsList || {}}
              value={props.formFilterValues?.client || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "client")}
              renderInput={(params) => <TextField {...params} label="Client" name="client" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="fridgesTypeInput"
              options={fridgesTypesList || {}}
              value={props.formFilterValues.fridgesType || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "fridgesType")}
              renderInput={(params) => <TextField {...params} label="Fridges Type" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="operationsTypeInput"
              options={operationsList || {}}
              value={props.formFilterValues.operationType || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "operationType")}
              renderInput={(params) => <TextField {...params} label="Operations Type" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="statusInput"
              options={statusList}
              value={props.formFilterValues.status || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "status")}
              renderInput={(params) => <TextField {...params} label="Status" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={props.formFilterValues.fromDate}
              id="fromDate"
              name="fromDate"
              label="From Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={props.formFilterValues.toDate}
              id="toDate"
              name="toDate"
              label="To Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={() => props.setOpenDialog(false)}
          startIcon={<Close />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={handleOnSubmit}
          startIcon={<Save />}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default FilterComponent;
